<section class="progress-section vw-100">
  <div class="header-container">
    <div class="progress-header d-flex align-items-center justify-content-between mt-24 pl-16 pr-16 pb-16">
      <h2 class="d-flex align-items-center fts-16 font-bold-dali m-0 pr-16">
        <img src="assets/image/sliders-horizontal _black.svg" alt="icono filtrar" class="mr-8 icon-img" />
        Filtra tu información
      </h2>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <img src="assets/image/modal/close-modal.svg" alt="cerrar" width="16px" />
      </button>
    </div>
    <div class="dl-divider"></div>
  </div>

  <div class="body-container">
    <!-- Contenido scrollable -->
    <!-- 1 -->
    <div class="custom-select-container pl-16 pv-16 pr-10">
      <!-- CABECERA -->
      <div class="custom-select-header d-flex align-items-center justify-content-between" (click)="toggleSelect()">
        <span class="custom-select-placeholder fts-16 font-bold-dali color-title-custom">
          {{ selectedLabel || 'Estado' }}
        </span>
        <span class="material-symbols-rounded color-active">
          {{ isOpenStatus ? 'expand_less' : 'expand_more' }}
        </span>
      </div>

      <!-- PANEL DE OPCIONES -->
      <div class="custom-select-panel mt-16" *ngIf="isOpenStatus" [@expandAnimation]>
        <div *ngFor="let option of statusList" class="custom-option checkbox-row mb-8">
          <span class="option-label fts-14 font-regular color-title-custom">
            {{ option.label }}
          </span>

          <mat-checkbox [(ngModel)]="option.checked" (change)="onCheckboxChange(option, statusList)"
            class="checkbox-only custom-checkbox"></mat-checkbox>
        </div>
      </div>
    </div>
    <!-- 2 -->
    <div class="custom-select-container pl-16 pv-16 pr-10 mt-16">
      <!-- CABECERA -->
      <div class="custom-select-header d-flex align-items-center justify-content-between"
        (click)="toggleSelectClient()">
        <span class="custom-select-placeholder fts-16 font-bold-dali color-title-custom">
          {{ selectedLabel || 'Clientes' }}
        </span>
        <span class="material-symbols-rounded color-active">
          {{ isOpenClient ? 'expand_less' : 'expand_more' }}
        </span>
      </div>

      <!-- PANEL DE OPCIONES -->
      <div class="custom-select-panel mt-16 container-client" *ngIf="isOpenClient" [@expandAnimation]>
        <div *ngFor="let client of customersList" class="custom-option checkbox-row mb-8">
          <span class="option-label fts-14 font-regular color-title-custom">
            <span *ngIf="client.code != 'all' && client.code != 'otros' && client.code != 'ninguno'">
              {{ client.code }}-
            </span>
            {{ client.name }}
          </span>


          <mat-checkbox [(ngModel)]="client.checked" (change)="onCheckboxChange(client, customersList)"
            class="checkbox-only custom-checkbox"></mat-checkbox>
        </div>
      </div>
    </div>
    <!-- 3 -->
    <div class="custom-select-container pl-16 pv-16 pr-10 mt-16">
      <!-- CABECERA -->
      <div class="custom-select-header d-flex align-items-center justify-content-between"
        (click)="toggleSelectVisibility()">
        <span class="custom-select-placeholder fts-16 font-bold-dali color-title-custom">
          {{ selectedLabel || 'Visibilidad cliente' }}
        </span>
        <span class="material-symbols-rounded color-active">
          {{ isOpenVisibility ? 'expand_less' : 'expand_more' }}
        </span>
      </div>

      <!-- PANEL DE OPCIONES -->
      <div class="custom-select-panel mt-16" *ngIf="isOpenVisibility" [@expandAnimation]>
        <div *ngFor="let option of visibilityList" class="custom-option checkbox-row mb-8">
          <span class="option-label fts-14 font-regular color-title-custom">
            {{ option.label }}
          </span>

          <mat-checkbox [(ngModel)]="option.checked" (change)="onCheckboxChange(option, visibilityList)"
            class="checkbox-only custom-checkbox"></mat-checkbox>
        </div>
      </div>
    </div>
    <!-- 4 -->
    <div class="custom-select-container pl-16 pv-16 pr-10 mt-16">
      <!-- CABECERA -->
      <div class="custom-select-header d-flex align-items-center justify-content-between"
        (click)="toggleSelectExecutionDate()">
        <span class="custom-select-placeholder fts-16 font-bold-dali color-title-custom">
          {{ selectedLabel || 'Fecha de ejecución' }}
        </span>
        <span class="material-symbols-rounded color-active">
          {{ isOpenExecutionDate ? 'expand_less' : 'expand_more' }}
        </span>
      </div>

      <!-- PANEL DE OPCIONES -->
      <div class="custom-select-panel mt-16" *ngIf="isOpenExecutionDate" [@expandAnimation]>
        <div class="d-flex align-items-center justify-content-between">
          <img src="assets/svg/support-warning-medium.svg" alt="alert" class="mr-8" />
          <p class="m-0 p-0 fts-14 line-height-16 font-regular">
            {{ executionDateText }}
          </p>
        </div>
        <div class="dl-divider mt-16 mb-16"></div>

        <!-- 🗓️ Fechas -->
        <div class="container-date align-items-center justify-content-center">
          <!-- 📅 Fecha de inicio -->
          <div class="date-start">
            <p class="custom-select-placeholder fts-14 font-bold-dali color-title-custom m-0 p-0">
              Fecha de inicio
            </p>
            <mat-form-field class="datepicker-input-40 font-regular fts-14 flex-grow-1 datepicker-container mt-8"
              floatLabel="never">
              <mat-label class="fts-14 font-regular">Elige una fecha</mat-label>
              <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate"
                [matDatepickerInputFormat]="'dd MMM'" (dateChange)="onStartDateChange($event.value)"
                placeholder="Elige una fecha"  (input)="formatDateInput($event, 'start')" readonly/>
              <mat-datepicker-toggle matSuffix [for]="startPicker" class="mat-datepicker-toggle custom-toggle">
                <mat-icon matDatepickerToggleIcon [svgIcon]="
              isLoadingRegistrationService || isErrorRegistrationService
                ? 'datepicker_icon_disabled'
                : 'datepicker_icon'
            "></mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>

          </div>
          <div class="date-end"> 
            <!-- 📅 Fecha de fin -->
            <p class="custom-select-placeholder fts-14 font-bold-dali color-title-custom m-0 p-0">
              Fecha de fin
            </p>
            <mat-form-field class="datepicker-input-40 font-regular fts-14 flex-grow-1 datepicker-container mt-8"
              floatLabel="never">
              <mat-label class="fts-14 font-regular">Elige una fecha</mat-label>
              <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate" [matDatepickerInputFormat]="'dd MMM'"
                placeholder="Elige una fecha" [matDatepickerFilter]="filterEndDate"
                (dateChange)="onEndDateChange($event.value)" readonly/>
              <mat-datepicker-toggle matSuffix [for]="endPicker" class="mat-datepicker-toggle custom-toggle">
                <mat-icon matDatepickerToggleIcon [svgIcon]="
              isLoadingRegistrationService || isErrorRegistrationService
                ? 'datepicker_icon_disabled'
                : 'datepicker_icon'
            "></mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="footer-container">
    <button mat-flat-button class="btn-cancel btn-cancel-width d-flex justify-content-center align-items-center font-semiBold fts-14"
      (click)="close()">Cancelar

    </button>
    <button mat-flat-button
      class="btn-cancel btn-clear-width d-flex justify-content-center align-items-center font-semiBold fts-14 ml-16 ph-18"
      (click)="clearFilters()" [disabled]="!hasActiveFilters()">Limpiar

    </button>
    <button mat-flat-button
      class="btn-green p-12 font-semiBold fts-14  ml-16 d-flex align-items-center justify-content-center"
      (click)="applyFilters()">Aplicar
      filtros</button>
  </div>
</section>